import React, { useEffect, useState } from "react";
import MainLayout from "../layouts/MainLayout";

import { Button } from "../components/Button/Button";
import { InputField, NewSelectField } from "../components/FormItems/FormItems";
import { DayPicker } from "react-day-picker";
import "react-day-picker/style.css";
import ThankyouPage from "../components/ThankyouPage/ThankyouPage";
import { fetchPageData } from "../endpoint/pageApi";
import MultipleIcon from "../components/MutipleIcons/MultipleIcon";
import { useMediaQuery } from "react-responsive";
import { LoadingOutlined } from "@ant-design/icons";
import {
  _1200px,
  _1400px,
  _1500px,
  _1600px,
  _1700px,
  _1800px,
  _576px,
  _768px,
  _992px,
} from "../utils/mediaBreakpoints";
import { useSearchParams, useSubmit } from "react-router-dom";
import axios from "axios";
import { apiToken, backendUrl, baseUrl } from "../utils/base_url";
import { Toaster, toast } from "react-hot-toast";
import { onSubmit } from "../components/BlogListing/SingleBlog";
import { Tabs } from "antd";

const Schedule = () => {
  const [pageData, setPageData] = useState({});
  const [loader, setLoader] = useState(false);
  const [searchParams] = useSearchParams();
  const [formType, setFormType] = useState(searchParams.get("type"));

  useEffect(() => {
    const type = searchParams.get("type");
    setFormType(type);
  }, [searchParams]);

  useEffect(() => {
    fetchPageData(
      "pages?filters[slug][$eq]=schedule-a-demo",
      setPageData,
      setLoader
    );
  }, []);
  const paragraphs = [
    {
      para: "Lorem ipsum dolor sit amet consectetur. Ullamcorper turpis in eros etiam. Quam tempus hac morbi ullamcorper venenatis ultrices facilisis. Blandit ut integer etiam egestas pellentesque lorem felis facilisis. Imperdiet pellentesque augue tincidunt feugiat facilisi feugiat accumsan netus quisque.",
    },
    {
      para: "Lorem ipsum dolor sit amet consectetur. Ullamcorper turpis in eros etiam. Quam tempus hac morbi ullamcorper venenatis ultrices facilisis. Blandit ut integer etiam egestas pellentesque lorem felis facilisis. Imperdiet pellentesque augue tincidunt feugiat facilisi feugiat accumsan netus quisque.",
    },
  ];
  return (
    <MainLayout loader={loader}>
      <ScheduleForm data={pageData} formType={formType} />

      {/* Thank You Page On Form Submission */}
      {/* <ThankyouPage
        msg="Your call with our investor relations team is booked successfully"
        appreciationHeading="Thank you!"
        paragraphs={paragraphs}
        buttonName="Back to Home"
      /> */}
    </MainLayout>
  );
};

const ScheduleForm = ({ data, formType }) => {
  // const [selected, setSelected] = useState();

  const [selectedTab, setSelectedTab] = useState();
  const [items, setItems] = useState([]);
  const [selectedForm, setSelectedForm] = useState({});
  const _576 = useMediaQuery({ maxWidth: _576px });
  const _768 = useMediaQuery({ maxWidth: _768px });
  const _992 = useMediaQuery({ maxWidth: _992px });
  const _1200 = useMediaQuery({ maxWidth: _1200px });
  const _1400 = useMediaQuery({ maxWidth: _1400px });
  const _1500 = useMediaQuery({ maxWidth: _1500px });
  const _1600 = useMediaQuery({ maxWidth: _1600px });
  const _1700 = useMediaQuery({ maxWidth: _1700px });
  const _1800 = useMediaQuery({ maxWidth: _1800px });
  console.log("shData", data);
  const [formData, setFormData] = useState({});
  const [requiredFields, setRequiredFields] = useState(false);

  const [btnLoader, setBtnLaoder] = useState(false);
  const onTabChange = (v) => {
    setSelectedTab(v);

    const selected = data?.multiple_forms?.forms?.find(
      (element) => element?.pageKey === v
    );
    setSelectedForm(selected);
  };

  useEffect(() => {
    console.log(formType);

    if (formType === "contact") {
      onTabChange("contact");
      setItems([]);
      return;
    }

    onTabChange("student");

    const forms = data?.multiple_forms?.forms;
    if (!Array.isArray(forms) || forms.length === 0) return;

    const tempItems = forms
      .filter((item) => {
        if (formType !== "contact" && item.pageKey === "contact") return false;
        return true;
      })
      .map((item) => ({
        label: <span className="p-2">{item.heading}</span>,
        key: item.pageKey,
      }));

    setItems(tempItems);
  }, [data, formType]);

  useEffect(() => {
    let formFields = selectedForm?.form?.fields;
    const keys = formFields?.map((item) => item?.name);
    let objects = keys?.map((key) => {
      return {
        [key]: "",
      };
    });
    const normalized = {};
    const keyCount = {}; // to count duplicate keys

    objects?.forEach((obj) => {
      const key = Object.keys(obj)[0];
      const value = obj[key];
      console.log(key, value);

      // Count duplicates
      if (keyCount[key]) {
        keyCount[key]++;
        normalized[key] = value;
      } else {
        keyCount[key] = 1;
        normalized[key] = value;
      }
    });
    console.log(normalized);

    setFormData(normalized);

    const hasRequired = formFields?.some((field) => field.required === true);

    setRequiredFields(hasRequired);
  }, [selectedForm, data]);

  const SubmitForm = async () => {
    // for strapi form
    const payload = {
      formData: {
        "First Name": formData["firstName"],
        "Last Name": formData["lastName"],
        Email: formData["email"],
        "Company Name": formData["companyName"],
        Country: formData["country"],
        "Job Title": formData["jobTitle"],
        "Organization Type": formData["organizationType"],
        "Team Size": formData["teamSize"],
        "How did you hear about us?": formData["howAboutUs"],
        "What are you contacting us about?": formData["contactingUs"],
      },
      token: "",
      formName: "Schedule a Demo Form",
    };

    // for backend form
    const payloadd = {
      first_name: formData["firstName"],
      last_name: formData["lastName"],
      email: formData["email"],
      company_name: formData["companyName"],
      country: formData["country"],
      job_title: formData["jobTitle"],
      organization_type: formData["organizationType"],
      team_size: formData["teamSize"],
      hear_about: formData["howAboutUs"],
      message: formData["contactingUs"],
    };

    console.log(payloadd);

    // if (requiredFields && (!formData["firstName"] || !formData["lastName"] || !formData["email"] || !formData["companyName"] || !formData["country"] || !formData["jobTitle"] || !formData["organizationType"] || !formData["teamSize"] || !formData["howAboutUs"] || !formData["contactingUs"])) {
    //   toast.error("Please fill all the required fields")
    //   return;
    // }

    try {
      setBtnLaoder(true);
      // for strapi form
      let res = await axios.post(`${baseUrl}/api/ezforms/submit`, payload, {
        headers: {
          Authorization: `Bearer ${apiToken}`,
        },
      });
      // for backend form
      // let res = await axios.post(`${backendUrl}/demo-form/contact/submit`, payloadd);
      console.log(res);
      // toast.success("Operation successful!");
      // toast.success(res?.data?.message);
      toast.success(
        `${formData["firstName"]} ${formData["lastName"]} Your Demo Request Submitted!`
      );
      setBtnLaoder(false);
      setTimeout(() => {
        window.location.reload();
      }, 2500);
    } catch (e) {
      console.log(e);
      setBtnLaoder(false);
      // alert(e)
      toast.error("Something went wrong!");
    }
  };

  return (
    <>
      <div style={{ background: "#090D24" }}>
        <div className="container contwidth p-0">
          <Toaster position="top-center" />
          <div className="row g-0 ">
            <div className="col-12">
              <div className="d-flex justify-content-between mt-5">
                <div className="d-flex flex-column pb-lg-5 me-5 pe-5 align-self-center align-self-lg-start">
                  <span
                    className="text-white"
                    style={{
                      fontSize: _576
                        ? "25px"
                        : _768
                        ? "45px"
                        : _992
                        ? "50px"
                        : _1200
                        ? "55px"
                        : _1400
                        ? "60px"
                        : _1500
                        ? "63px"
                        : _1600
                        ? "65px"
                        : _1700
                        ? "70px"
                        : _1800
                        ? "75px"
                        : "90px",

                      fontWeight: "900",
                    }}
                  >
                    {selectedForm?.heading}
                  </span>
                  <div className="pt-2">
                    <Tabs
                      defaultActiveKey={selectedTab}
                      items={items}
                      onChange={(v) => onTabChange(v)}
                      className="custom-tabs"
                    />
                  </div>
                  <span
                    className="text-white "
                    style={{
                      fontSize: _576
                        ? "16px"
                        : _768
                        ? "20px"
                        : _992
                        ? "20px"
                        : _1200
                        ? "25px"
                        : _1400
                        ? "30px"
                        : _1600
                        ? "30px"
                        : _1700
                        ? "35px"
                        : _1800
                        ? "40px"
                        : "40px",

                      fontWeight: "400",
                    }}
                  >
                    {selectedForm?.page_title}
                  </span>
                </div>
                {/* <MultipleIcon direction="column align-self-center pt-lg-4" /> */}
              </div>
            </div>

            {/* <div className="col-md-6">
                <div className="d-flex flex-column gap-3">
                  <span className="fs-5 fw-semibold text-white">
                    Pick a Date and Time
                  </span>
                  <div
                    className="rounded-4 p-5 d-flex align-items-center justify-content-center w-75"
                    style={{ background: "#151515" }}
                  >
                    <DayPicker
                      mode="single"
                      selected={selected}
                      onSelect={setSelected}
                      className="text-white fs-5 "
                      //   footer={
                      //     selected
                      //       ? `Selected: ${selected.toLocaleDateString()}`
                      //       : "Pick a day."
                      //   }
                    />
                  </div>
                </div>
              </div> */}

            <div className="col-12 mt-5 px-md-5 py-5">
              <div className="d-flex flex-column gap-3">
                {/* <span className="fs-5 fw-semibold text-white">
                  Tell us about yourself
                </span> */}
                {/* Temp Condition fro Contact */}
                <form>
                  <div className="row gx-3 gy-4">
                    {selectedForm?.form?.fields?.map((field, idx) => {
                      const name = field?.name;

                      let options;
                      if (field?.type === "select") {
                        options = field?.options?.map((item) => {
                          return {
                            label: item,
                            value: item,
                          };
                        });
                      }

                      return (
                        <React.Fragment key={idx}>
                          {field?.type === "text" ||
                          field?.type === "email" ||
                          field?.type === "count" ? (
                            <InputField
                              name={name}
                              type={
                                field?.type === "count" ? "number" : field?.type
                              }
                              value={formData[name]}
                              className={`col-12 col-md-${field?.column}`}
                              label={field?.label}
                              newFormClassName={"new-form"}
                              onChange={(e) => {
                                setFormData({
                                  ...formData,
                                  [name]: e.target.value,
                                });
                              }}
                              required={field?.required}
                            />
                          ) : (
                            <NewSelectField
                              label={field?.label}
                              required={field?.required}
                              className={`col-12 col-md-${field?.column}`}
                              selectClassName={"new-form-select"}
                              search={true}
                              placeholder={"Select"}
                              value={formData[name]}
                              onChange={(e) => {
                                console.log(e);
                                setFormData({
                                  ...formData,
                                  [name]: e,
                                });
                              }}
                              option={options}
                            />
                          )}
                        </React.Fragment>
                      );
                    })}

                    <div className="col-12">
                      <span className="fs-6 " style={{ color: "#90A3BE" }}>
                        {selectedForm?.form?.desclaimer}
                      </span>
                    </div>

                    <div className="col-12">
                      {selectedForm?.form?.CTAs?.map((button, idx) => (
                        <React.Fragment key={idx}>
                          <Button
                            disabled={btnLoader}
                            className={"px-5 py-1 rounded-pill"}
                            textColor={button?.textColor}
                            background={button?.backgroundColor}
                            onClick={() => SubmitForm()}
                          >
                            {btnLoader ? <LoadingOutlined /> : button?.text}
                            {/* {button?.text} */}
                          </Button>
                        </React.Fragment>
                      ))}
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <InformedCard data={data} />
    </>
  );
};

export const InformedCard = ({ data }) => {
  const _576 = useMediaQuery({ maxWidth: _576px });
  const _768 = useMediaQuery({ maxWidth: _768px });
  const _992 = useMediaQuery({ maxWidth: _992px });
  const _1200 = useMediaQuery({ maxWidth: _1200px });
  const _1400 = useMediaQuery({ maxWidth: _1400px });
  const _1500 = useMediaQuery({ maxWidth: _1500px });
  const _1600 = useMediaQuery({ maxWidth: _1600px });
  const _1700 = useMediaQuery({ maxWidth: _1700px });
  const _1800 = useMediaQuery({ maxWidth: _1800px });
  const [btnLoader, setBtnLaoder] = useState(false);
  return (
    <div style={{ background: "#000", padding: "2rem 0rem" }}>
      <div className="container contwidth  p-0">
        <div>
          {data?.stay_informeds?.map((item, idx) => (
            <div
              key={idx}
              style={{
                background: item?.backgroundColor,
              }}
            >
              <div className="row py-5 g-0">
                <div
                  className={`d-flex flex-column text-white ${
                    _1200 ? "col-12" : "col-8"
                  } `}
                >
                  <span
                    style={{
                      fontWeight: "700",
                      fontSize: _576
                        ? "25px"
                        : _768
                        ? "30px"
                        : _992
                        ? "30px"
                        : _1200
                        ? "25px"
                        : _1400
                        ? "28px"
                        : _1500
                        ? "30px"
                        : _1600
                        ? "33px"
                        : _1700
                        ? "33px"
                        : _1800
                        ? "38px"
                        : "40px",
                      lineHeight: "100%",
                    }}
                  >
                    {item?.heading}
                  </span>
                  <span
                    className="mt-3"
                    style={{
                      fontWeight: "400",
                      fontSize: "20px",
                      lineHeight: "150%",
                      width: _1500 ? "80%" : "90%",
                    }}
                  >
                    {item?.sub_heading}
                  </span>
                </div>
                <form
                  onSubmit={(e) => onSubmit(e, setBtnLaoder)}
                  className={`d-flex ${
                    _576 ? "flex-column align-items-center " : "flex-nowrap"
                  } align-items-end justify-content-center justify-content-lg-end col-12 col-lg-4 mt-xl-0 mt-4 mx-auto`}
                  style={{ width: _576 ? "100%" : "" }}
                >
                  {/* <> */}
                  <InputField
                    name={"email"}
                    type={"email"}
                    newFormClassName={`${
                      _576
                        ? "rounded-4 stay-informed-input"
                        : "stay-informed-input"
                    }`}
                    placeholder={"Enter your email"}
                    width={_576 ? "100%" : "250px"}
                    padding={_576 ? "15px 35px" : "27px 32px"}
                  />

                  <Button
                    type={"submit"}
                    background={item?.CTA?.backgroundColor}
                    textColor={item?.CTA?.textColor}
                    newButtonClassName={`${
                      _576
                        ? "rounded-4 mt-3 border-0 fs18 stay-informed-button fw-bold"
                        : "stay-informed-button fw-bold"
                    }`}
                    padding={_576 ? "12px 70px" : "26px 32px "}
                    // width={}
                    // height={_768?"50%":""}
                  >
                    {item?.CTA?.text}
                  </Button>
                </form>
                {/* </div> */}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
export default Schedule;
